import {auditlogService} from "@/modules/auditlog/services/auditlogService.js";

const state = {
  auditlogs: [],
  hasLoadedAuditlogs: false,
  currentPageIndex: 1,
  perPage: 10,
  filterText: '',
  filterBy: '',
  filterEntity: '',
  hasAuditlogs: false,
  filterDate: {
    applied : false,
    from : null,
    to : null,
  },
};

const getters = {
  auditlogs: (state) => state.auditlogs,
  filteredAuditlogs: (state) => {
      return state.auditlogs
  },
  hasLoadedAuditlogs: (state) => state.hasLoadedAuditlogs,
  filterText: (state) => state.filterText,
  filterBy: (state) => state.filterBy,
  filterEntity: (state) => state.filterEntity,
  filterDate: (state) => state.filterDate,
  hasAuditlogs: state => state.hasAuditlogs,
  auditlogIdMap: state => {
    const res = {};
    state.auditlogs.forEach(auditlog => res[auditlog.id] = true)
    return res
  }
};

const mutations = {
  setAuditlogs(state, auditlogs) {
    state.auditlogs = auditlogs
  },
  setLoadedAuditlogs(state, hasLoadedAuditlogs) {
    state.hasLoadedAuditlogs = hasLoadedAuditlogs
  },
  incrementCurrentPageIndex(state) {
    state.currentPageIndex++;
  },
  setFilterText(state, filterText ) {
    state.filterText = filterText || ''
  },
  setFilterBy(state, filterBy ) {
    state.filterBy = filterBy || ''
  },
  setFilterEntity(state, filterEntity ) {
    state.filterEntity = filterEntity || ''
  },
  setFilterDate(state, filterDate ) {
    state.filterDate = filterDate || {}
  },
  resetParameters(state) {
    state.currentPageIndex = 1
    state.hasLoadedAuditlogs = false
  },
  setHasAuditlogs(state, hasAuditlogs) {
    state.hasAuditlogs = hasAuditlogs
  },
}

const actions = {
  async loadAuditlogs({commit, state, getters}, resetAuditlogs = false) {
    if(resetAuditlogs) {
      commit('resetParameters')
    } else {
      if(state.hasLoadedAuditlogs) {
        return
      }
    }

    const getParams = {per_page: state.perPage, page: state.currentPageIndex}

    if(state.filterBy) {
      if (state.filterText && state.filterBy.toLocaleLowerCase() === 'staff_uid') {
        getParams['filter[actor_type]'] = 'staff'
        getParams['filter[actor_uid]'] = state.filterText
      } else if (state.filterText && state.filterBy.toLocaleLowerCase() === 'client_uid') {
        getParams['filter[client_uid]'] = state.filterText
      } else if (state.filterBy.toLocaleLowerCase() === 'entity_type' && state.filterEntity && state.filterEntity !== '') {
        getParams['filter[entity_type]'] = state.filterEntity
        if (state.filterText && state.filterText !== '') {
          getParams['filter[entity_uid]'] = state.filterText
        }
      }
    }

    if (state.filterDate.applied) {
      getParams['filter[from]'] = state.filterDate.from
      getParams['filter[to]'] = state.filterDate.to
    }

    let audit_logs = (await auditlogService.get(getParams)).data.audit_logs
    if(resetAuditlogs) {
      commit('setAuditlogs', [])
    }
    audit_logs = audit_logs || []
    if (audit_logs.length < state.perPage) {
      commit('setLoadedAuditlogs', true)
    }
    const auditlogIdMap = getters.auditlogIdMap
    let res = resetAuditlogs ? audit_logs : state.auditlogs.concat(audit_logs.filter(auditlog => !auditlogIdMap[auditlog.id]))
    commit('setAuditlogs', res)
    commit('incrementCurrentPageIndex')
    return res
  },
  async setFilterText({commit, state, dispatch}, filterText) {
    commit('setFilterText', filterText)
    await dispatch('loadAuditlogs', true)
  },
  async setFilterBy({commit, state, dispatch}, filterBy) {
    commit('setFilterBy', filterBy)
    await dispatch('loadAuditlogs', true)
  },
  async setFilterEntity({commit, state, dispatch}, filterEntity) {
    commit('setFilterEntity', filterEntity)
    await dispatch('loadAuditlogs', true)
  },
  async setFilterDate({commit, state, dispatch}, filterDate) {
    const filterDatecopy = {...filterDate}
    filterDatecopy.from = convertDateToUTC(filterDate.from)
    filterDatecopy.to = convertDateToUTC(filterDate.to)
    commit('setFilterDate', filterDatecopy)
    await dispatch('loadAuditlogs', true)
  },
  async setHasAuditlogs({commit}) {
    const getParams = {per_page: 10, page: 1}
    let audit_logs = (await auditlogService.get(getParams)).data.audit_logs
    const res = !!audit_logs.length
    commit('setHasAuditlogs', res)
    return res
  },
}

function convertDateToUTC(dateStr){
  const date = new Date(dateStr)
  return date.toISOString().slice(0, -1)
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
